import { Platform } from 'react-native';
import ExpoConstants from 'expo-constants';
import * as Crypto from 'expo-crypto';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import Constants from 'src/core/utils/Constants';
import type AnalyticsEventParams from 'src/core/models/AnalyticsEventParams';
import type AnalyticsUser from 'src/core/models/AnalyticsUser';

const TAG = '[AnalyticsService] ->';

const firebaseConfig = ExpoConstants.expoConfig?.web?.config?.firebase;
const webAnalytics = firebaseConfig ? getAnalytics(initializeApp(firebaseConfig)) : null;

class AnalyticsService {
	setCollectionEnabled(enabled: boolean) {
		// Web has no equivalent toggle; collection follows the Firebase web config.
	}

	async sendEvent({
		name,
		params,
		user,
	}: {
		name: string;
		params: AnalyticsEventParams;
		user: AnalyticsUser | null;
	}): Promise<void> {
		if (!webAnalytics) {
			console.warn(TAG, 'No Firebase web config for this environment, skipping event', name);
			return;
		}

		params[Constants.analyticsParamPlatform] = Platform.OS;

		if (user) {
			params[Constants.analyticsParamUserId] = await Crypto.digestStringAsync(
				Crypto.CryptoDigestAlgorithm.SHA256,
				user.email,
			);
		}

		logEvent(webAnalytics, name, params);
	}
}

export default new AnalyticsService();
